import { InjectionToken } from '@angular/core'
import { User } from '@auth0/auth0-spa-js'
import { Observable } from 'rxjs'

export abstract class BaseAuthService {
  abstract get userProfile(): User
  abstract userProfile$: Observable<User>
}
export const AUTH_SERVICE = new InjectionToken<BaseAuthService>('AUTH_SERVICE')
